/**
 * API class singleton registration
 */
import AuthService from './lynxauth'
import constants from '@/constants'
import StatusService from './lynxstatus'
import ReferentialService from './lynxref'
import ContactService from './lynxcontacts'
import OppService from './lynxopps'
import DocumentService from './lynxdoc'
import EntityService from './lynxentities'

export const AuthServiceInstance = new AuthService(constants.api_url)
export const StatusServiceInstance = new StatusService(constants.api_url)
export const RefServiceInstance = new ReferentialService(constants.api_url)
export const ContactSvcInstance = new ContactService(constants.api_url)
export const OppSvcInstance = new OppService(constants.api_url)
export const DocSvcInstance = new DocumentService(constants.api_url)
export const EntSvcInstance = new EntityService(constants.api_url)
